import http from '../../request/index'
class BuryPoint {
  constructor() {}
  init(Vue) {
    //自动埋点
    /* 
{
         需要曝光的元素class
         cssSelector: '.auto-exp-component',
         如果页面模块是元素内滚动（某个区块内有滚动条）则需要增加positionSelector辅助定位曝光元素
         positionSelector: '',
         logkey: 'WKSUM_SHOW_FINISH', // 事件管理中的事件id
         props: [] // 你要曝光的元素身上自定义属性
       }
*/
    Vue.prototype.$autoBuryPoint = function (list) {
      if (Array.isArray(list) && list.length) {
        window['aplus_queue'] &&
          window['aplus_queue'].push({
            action: 'aplus.setMetaInfo',
            arguments: ['aplus-auto-exp', list]
          })
      }
    }
    /* 埋点 */
    Vue.prototype.$buryPoint = function (eventCode, eventParams) {
      //暂时在友盟埋点的同时调用betterwe项目后台统计
      http.addDataLog({
        eventk: eventCode,
        eventv: JSON.stringify(eventParams)
      })
      window['aplus_queue'] &&
        window['aplus_queue'].push({
          action: 'aplus.record',
          arguments: [eventCode, 'CLK', eventParams]
        })
    }
  }
}
export default new BuryPoint()
